/* eslint-disable react/forbid-prop-types,react/jsx-props-no-spreading */
import React from 'react';
import { FormField, Label, Input } from 'semantic-ui-react';
import PropTypes from 'prop-types';

function ValidatedFormInput({ input, meta, messagePointing, ...rest }) {
  // added double exclamation (!!) to explicitly indicate we want the true or false value

  const errorContent = meta.touched && !!meta.error && meta.error;

  return (
    <FormField error={errorContent}>
      <Input {...input} {...rest} />
      {errorContent && (
        <Label prompt content={errorContent} pointing={messagePointing} />
      )}
    </FormField>
  );
}

ValidatedFormInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  messagePointing: PropTypes.string,
};

ValidatedFormInput.defaultProps = {
  messagePointing: 'above',
};

export default ValidatedFormInput;
